<template>
  <v-dialog v-model="showMessage" persistent max-width="490">
    <v-card>
      <v-card-title>
        <h5 class="pt-5 pb-7">Mensagem</h5>
      </v-card-title>
      <v-card-text>{{ message }}</v-card-text>
      <v-spacer></v-spacer>
      <v-card-actions class="px-6 py-5">
        <v-btn color="gray" text large class="px-12" @click="closeCrudMessage()"
          >Entendi</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    showMessage: {
      type: Boolean,
      default: false,
      required: true
    },
    message: {
      type: String,
      default: "",
      required: true
    }
  },
  name: "CrudMessageResponse",
  data: () => ({}),
  methods: {
    closeCrudMessage() {
      this.showMessage = false;
      this.message = "";
      this.messageTitle = "";
      this.$emit("close");
    }
  }
};
</script>